import * as React from "react"

const SvgGive = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15.875 5.71436C19.741 5.71436 22.875 8.84836 22.875 12.7144C22.875 16.5803 19.741 19.7144 15.875 19.7144C14.8012 19.7144 13.7844 19.4716 12.875 19.0396C11.9656 19.4716 10.9488 19.7144 9.875 19.7144C6.00901 19.7144 2.875 16.5803 2.875 12.7144C2.875 8.84836 6.00901 5.71436 9.875 5.71436C10.9486 5.71436 11.9657 5.95622 12.875 6.38818C13.7843 5.95622 14.8014 5.71436 15.875 5.71436ZM9.875 7.71436C7.11358 7.71436 4.875 9.95293 4.875 12.7144C4.875 15.4758 7.11358 17.7144 9.875 17.7144C10.2178 17.7144 10.5525 17.6795 10.876 17.6138C9.63838 16.3512 8.875 14.622 8.875 12.7144C8.875 10.8064 9.63809 9.07661 10.876 7.81396C10.5526 7.74826 10.2178 7.71436 9.875 7.71436ZM15.875 7.71436C15.5319 7.71436 15.1967 7.74814 14.873 7.81396C16.1112 9.07665 16.875 10.8062 16.875 12.7144C16.875 14.6223 16.1109 16.3511 14.873 17.6138C15.1968 17.6796 15.5318 17.7144 15.875 17.7144C18.6364 17.7144 20.875 15.4758 20.875 12.7144C20.875 9.95293 18.6364 7.71436 15.875 7.71436Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgGive
